import { CropRect } from "../../utils/videoTrim";

export type UploadSourceKind = "trimmed" | "original_fallback";

export type TeacherWebUploadDraft = {
  bucket: string;
  cdnDomain: string | null;
  cropRect: CropRect;
  durationSec: number;
  exportError: string | null;
  fileSize: number;
  linkId: number;
  mimeType: string;
  objectKey: string;
  originalFileName: string;
  originalFileSize: number;
  originalMimeType: string;
  originalVideoDurationSec: number;
  originalVideoHeight: number;
  originalVideoWidth: number;
  region: string;
  sourceKind: UploadSourceKind;
  startTimeSec: number;
  studentUserId: number;
  teacherToken: string;
  teacherUserId: number;
  uploadedAt: string;
};

function draftStorageKey(token: string, userId: number): string {
  return `pingpi.teacherWeb.uploadDraft.v1.${token}.${userId}`;
}

export function clearUploadDraft(token: string, userId: number): void {
  try {
    window.localStorage.removeItem(draftStorageKey(token, userId));
  } catch {
    // Some embedded browsers restrict storage. Clearing in-memory state is still enough.
  }
}
